 
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetDraweeBankService {

  constructor(private http: HttpClient) {}

  async GetBankDrawee() {
    try { 
      let response = await this.http
        .get(`${appApiResources.getDraweeBank}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}